import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import store from './store'; // Import the store
import './assets/index.css';
import 'flowbite/dist/flowbite.js';
import 'flowbite/dist/flowbite.css';
import VueGtag from 'vue-gtag';

// Correct import for SCORM_API
import { SCORM_API } from './scorm-api'; // Adjust path as needed

const app = createApp(App);

// Check if user is authenticated and retrieve token from local storage
const token = localStorage.getItem('token');

// If token exists, set default Authorization header for Axios
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Make SCORM API globally available
window.API = SCORM_API;

app.config.globalProperties.$url = function (path) {
  const branchSlug = this.$route?.params?.branchSlug;
  return branchSlug ? `/branch/${branchSlug}${path.startsWith('/') ? path : '/' + path}` : path;
};

app.config.globalProperties.$routeWithBranch = function (name, options = {}) {
  const branchSlug = this.$route?.params?.branchSlug;

  // Prepend "Branch" to route name if inside a branch route
  const fullName = branchSlug && name && !name.startsWith('Branch')
    ? `Branch${name}`
    : name;

  return {
    name: fullName,
    ...(options || {}),
    params: {
      ...(options.params || {}),
      ...(branchSlug ? { branchSlug } : {})
    }
  };
};

app.config.globalProperties.$routerPushWithBranch = function (name, options = {}) {
  const branchSlug = this.$route?.params?.branchSlug;
  const fullName = branchSlug && name && !name.startsWith('Branch') ? `Branch${name}` : name;

  this.$router.push({
    name: fullName,
    ...(options || {}),
    params: {
      ...(options.params || {}),
      ...(branchSlug ? { branchSlug } : {})
    }
  });
};

app.use(VueGtag, {

  config: {

    id: process.env.VUE_APP_GT_ID,

  }

});

app.use(router);
app.use(store);
app.mount('#app');
